import { useContext } from 'react'
import { useMutation } from 'react-query'
import { apiPost } from 'api'
import AuthContext from 'context/auth-context'

const runAnalyticPreview = async (token, analyticId, configOverrides) => {
  const url = `analytics/${analyticId}/run`
  const data = await apiPost({
    url,
    token,
    objectName: 'config_overrides',
    params: configOverrides
  })
  return data
}

const confirmAnalyticImport = async (token, analyticId, outputKey, configOverrides) => {
  const url = `analytics/${analyticId}/import`
  const data = await apiPost({
    url,
    token,
    objectName: 'import',
    // config_overrides lets the backend persist tuned values into a custom
    // analytic's recipe (no-op for core analytics).
    params: { output_key: outputKey, config_overrides: configOverrides || {} }
  })
  return data
}

export const useRunAnalytic = ({ options = {} } = {}) => {
  const token = useContext(AuthContext)

  return useMutation(
    ({ analyticId, configOverrides }) =>
      runAnalyticPreview(token, analyticId, configOverrides),
    { ...options }
  )
}

export const useConfirmAnalytic = ({ options = {} } = {}) => {
  const token = useContext(AuthContext)

  return useMutation(
    ({ analyticId, outputKey, configOverrides }) =>
      confirmAnalyticImport(token, analyticId, outputKey, configOverrides),
    { ...options }
  )
}

